import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { BaseModelService } from './base-model.service'
import { PhoneControl } from './phone_control.model'
import { PhoneControlSerializer } from 'serializers'
import { KeyTransformer } from 'util/key-transformer'

export interface CSVImportParams {
  cityId: number
  course: string
  mark: number
  source: string
  rows: {
    licenseNumber: string
    firstName: string
    lastName: string
    middlename: string
    cityId: number
    course: string
    mark: number
    source: string
  }
}

export interface IStringOption {
  label: string
  value: string
}

export interface INumberOption {
  label: string
  value: number
}

@Injectable()
export class PhoneControlService extends BaseModelService<PhoneControl> {

  static ORIGIN_LABELS = {
    spy: 'Тайный покупатель',
    lighthouse: 'Маяк',
    rating: 'Блокировка в тарифе по рейтингу',
    education: 'Обучение',
    other: 'Другое'
  }

  SOURCE_OPTION_LIST: IStringOption[] = [
    { label: PhoneControlService.ORIGIN_LABELS['spy'], value: 'spy' },
    { label: PhoneControlService.ORIGIN_LABELS['lighthouse'], value: 'lighthouse' },
    { label: PhoneControlService.ORIGIN_LABELS['rating'], value: 'rating' },
    { label: PhoneControlService.ORIGIN_LABELS['other'], value: 'other' }
  ]

  MARK_OPTION_LIST: INumberOption[] = [
    { label: '1', value: 1 }, 
    { label: '2', value: 2 }, 
    { label: '5', value: 5 }
  ]

  constructor() {
    super()

    this.configure({
      basePath:  'phone_controls',
      key:       'phoneControl',
      pluralKey: 'phoneControls',
      serializer: PhoneControlSerializer
    })
  }

  cancel(id: number): Observable<Object> {
    let url = this.buildUrl(id, 'cancel')
    return this.patch(url)
  }

  import(params: CSVImportParams): Observable<Object> {
    const url = this.buildUrl("import")
    const body = JSON.stringify({
      phone_control: {
        import: KeyTransformer.underscore(params)
      }
    })
    return this.appHttp.post(url, body)
      .map(response => this.processResponse(response))
  }

  checkSidekiqState(id: number): Observable<Object> {
    const url = this.buildUrl(id, 'sidekiq_state')

    return this.get(url)
  }

  restart(id: number): Observable<Object> {
    const url = this.buildUrl(id, 'restart')

    return this.patch(url)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/phone_control.service.ts